





























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Badge } from '@/store/modules/lib'
import { namespace } from 'vuex-class'

import ModalLayout from '@/components/lfs/Badges/ModalLayout.vue'
import EmptyLinkList from '@/components/lfs/Badges/ListItems/EmptyLinkList.vue'
import LinkListHeader from '@/components/lfs/Badges/ListItems/LinkHeader.vue'
import ITrash from '@/components/icons/ITrash.vue'
import Search from "@/components/UI/Search.vue";

const dialog = namespace('dialog')
const forms = namespace('forms')

  interface ILink {
    type: string
    title: string
    value: string
  }

@Component({
  name: 'c-edit-link',

  components: {
    ModalLayout,
    EmptyLinkList,
    LinkListHeader,
    'i-trash': ITrash,
    Search
  }
})
export default class EditLink extends Vue {
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any

  @Prop(Object) badge!: Badge
  @Prop({type: [Boolean], default: false}) protected isCurrentCompany!: boolean

  isOpenModal: boolean = false
  linkId: string = ''

  link: ILink = {
    type: 'link',
    title: '',
    value: ''
  }
  get headers() {
    return [
      { text: this.$t('profile.contacts.table.title'), value: 'title', sortable: false, width: '150' },
      { text: this.$t('profile.contacts.table.data'), value: 'value', sortable: false, width: '100%' },
      { text: '', value: 'delete', sortable: false, width: '56' },
    ]
  }
    
  search:string = ''

  @Watch('isOpenModal')
  isOpenModalChanged (newValue: any) {
    if (!newValue) {
      this.link = {
        type: 'link',
        title: '',
        value: ''
      }
    }
  }

  get itemsSearch(){
   if(this.search ==='') return this.LinkListItem
    return this.LinkListItem.filter((el:any)=>{return el.value.toLowerCase().includes(this.search.toLocaleLowerCase()) || el.title.toLowerCase().includes(this.search.toLocaleLowerCase())})
  }

  get LinkListItem() {
    return this.badge.promo.filter(item => item.type == 'link')
  }

  get isSubmitDisabled () {
    return !(this.link.title && this.link.value)
  }

  openModal() {
    let options = {
      badge: this.badge,
      isCurrentCompany: this.isCurrentCompany
    }
    this.setOptions(options)
    this.SetTitleDialog(this.$t('profile.contacts.form.add_link'))
    this.SetFormSDialog('AddLinkForm')
    this.SetFullDialogShow(true)
  }

  closeModal () {
    this.isOpenModal = false
  }

  onDelete (item: ILink) {
    this.$emit('onDelete', { item, type: 'link' })
  }

  onSubmit () {
    this.$emit('onChange', { promo:[...this.badge.promo, this.link] })

    this.linkId = ''
    this.link = {
      type: 'link',
      title: '',
      value: ''
    }

    this.closeModal()
  }
}
